import { render, staticRenderFns } from "./SentEstimations.vue?vue&type=template&id=e66fce76&"
import script from "./SentEstimations.vue?vue&type=script&lang=js&"
export * from "./SentEstimations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports